import { 
  PlatformAdapter, 
  PermissionStatus, 
  NotificationOptions, 
  NotificationChannel,
  PendingNotification,
  DeliveredNotification
} from '../types';

/**
 * 简单适配器（用于不支持通知的平台）
 */
export class SimpleAdapter implements PlatformAdapter {
  async requestPermission(): Promise<PermissionStatus> {
    console.log('[SimpleAdapter] Request permission called');
    return 'granted';
  }
  
  async checkPermission(): Promise<PermissionStatus> {
    console.log('[SimpleAdapter] Check permission called');
    return 'granted';
  }
  
  async scheduleLocalNotification(options: NotificationOptions): Promise<string> {
    console.log('[SimpleAdapter] Schedule notification:', options);
    return options.id || 'simple-notification';
  }
  
  async cancelLocalNotification(id: string): Promise<void> {
    console.log('[SimpleAdapter] Cancel notification:', id);
  }
  
  async cancelAllLocalNotifications(): Promise<void> {
    console.log('[SimpleAdapter] Cancel all notifications');
  }
  
  async getPendingNotifications(): Promise<PendingNotification[]> {
    return [];
  }
  
  async getDeliveredNotifications(): Promise<DeliveredNotification[]> {
    return [];
  }
  
  async removeDeliveredNotifications(ids: string[]): Promise<void> {
    console.log('[SimpleAdapter] Remove delivered notifications:', ids);
  }
  
  async createChannel(channel: NotificationChannel): Promise<void> {
    console.log('[SimpleAdapter] Create channel:', channel);
  }
} 